import { default as calculationx64DrYmUVjMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detailaT6aVbc5xVMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquiryet4gtJSoMiMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_9380ZEyXPV9PMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45listbJVwgVCxenMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testing9em0JOSJh6Meta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyou9EwreWpamFMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upsellFR4I8SNAtWMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadostLIPwfbHTT0Meta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankvUudQRjwwBMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnanitvmiXKxU9tMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as pageIJgT7lXRWsMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testXjEalG0nMBMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepagebPvCuzrT7xMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articleBFS87EfRvAMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsMmQcKnre1ZMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagP7IUeQhCSaMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorp61SC366OwMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as category8pofJWD48hMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as section6Rnms558pOMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articles2VYTqh27s7Meta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryy5zbxtQDu8Meta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleypbQQNqddDMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionwDD2eCi3zVMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as contactPRB7QgMVEgMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45termination8aGl3CVM1MMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculationQFoppJCGhJMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45youHOv1Crb9ZSMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detailBzCLEenHumMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiry0u4LMi6Ko3Meta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45listKIyAMj3GQ1Meta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculationeayfbbZSKQMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youqdwhKDtihMMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquirysxQdaFMOCiMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listku5Ee3kvLXMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detail9sAb9yPET2Meta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offer6SChZS5RmCMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquirynYkI7LTzS6Meta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youJNnRu2ZYY1Meta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculationXMKCIvFHzaMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listVC6zYeBaZqMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youGWw86nMfo1Meta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlineC8nqWyjzWWMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailDoqE0zS1CZMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phoneQZwMNk75awMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offerE52mfv3xGfMeta } from "/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani/:leadId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadostLIPwfbHTT0Meta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankvUudQRjwwBMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnanitvmiXKxU9tMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: pageIJgT7lXRWsMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testXjEalG0nMBMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepagebPvCuzrT7xMeta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articleBFS87EfRvAMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsMmQcKnre1ZMeta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagP7IUeQhCSaMeta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorp61SC366OwMeta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: category8pofJWD48hMeta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: section6Rnms558pOMeta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articles2VYTqh27s7Meta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pageIJgT7lXRWsMeta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryy5zbxtQDu8Meta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleypbQQNqddDMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionwDD2eCi3zVMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionwDD2eCi3zVMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: contactPRB7QgMVEgMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45termination8aGl3CVM1MMeta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculationQFoppJCGhJMeta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45youHOv1Crb9ZSMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detailBzCLEenHumMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiry0u4LMi6Ko3Meta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45listKIyAMj3GQ1Meta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculationeayfbbZSKQMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youqdwhKDtihMMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquirysxQdaFMOCiMeta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listku5Ee3kvLXMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detail9sAb9yPET2Meta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offer6SChZS5RmCMeta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquirynYkI7LTzS6Meta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youJNnRu2ZYY1Meta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculationXMKCIvFHzaMeta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listVC6zYeBaZqMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youGWw86nMfo1Meta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlineC8nqWyjzWWMeta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailDoqE0zS1CZMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phoneQZwMNk75awMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offerE52mfv3xGfMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src1999057527/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]